import { Page, PageStatus } from "src/components";
import { MerchflowHeader } from "../../components/merchflows/MerchflowHeader/MerchflowHeader";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { useApi } from "src/api";
import { useAsyncState } from "src/hooks/useAsyncState";
import { sleep } from "src/utils/sleep";
import { MerchflowStepsNavigator } from "src/components/merchflows/MerchflowStepsNavigator/MerchflowStepsNavigator";
import { Color, Flex, Link, Text } from "src/elements";
import { PogOverview } from "../Merchflows_merchflowId_Stores_storeCode/components/PogOverview";
import { pages } from "src/utils";
import styled from "styled-components";
import { ResponseGetMercflows_merchflowId_S1_s1UserTriggerId } from "@CommonApi/merchflows/_merchflowId_/s1/_s1UserTriggerId_";
import { routeToUrl } from "@CommonUtils/routes";
import { S1LogsButton } from "./components/S1LogsButton";

const PogOverviewContainer = styled(Flex)`
  flex-direction: column;
  gap: 5px;
  * {
    pointer-events: none;
  }
`;

export const PageS1 = () => {
  const { merchflowId: _merchflowId, s1UserTriggerId: _s1UserTriggerId } = useParams();
  const merchflowId = Number(_merchflowId);
  const s1UserTriggerId = Number(_s1UserTriggerId);

  const { getMerchflowS1SolutionsApi } = useApi();

  const [data, setData] = useAsyncState<ResponseGetMercflows_merchflowId_S1_s1UserTriggerId>();

  useEffect(() => {
    loadS1Solutions();
  }, []);

  const loadS1Solutions = async () => {
    const response = await getMerchflowS1SolutionsApi(merchflowId, s1UserTriggerId);

    setData(
      response?.sort((s1Solution1, s1Solution2) =>
        s1Solution1.template_id < s1Solution2.template_id ? -1 : 1,
      ),
    );

    if (
      response?.find(
        (s1Solution) => s1Solution.status === "NOT_STARTED" || s1Solution.status === "IN_PROGRESS",
      )
    ) {
      await sleep(10_000);
      loadS1Solutions();
    }
  };

  const firstDoneS1Solution =
    data &&
    data.find((s1Solution) => {
      return s1Solution.status === "DONE";
    });

  return (
    <Page>
      <MerchflowHeader merchflowId={merchflowId} s1UserTriggerId={s1UserTriggerId} />

      <MerchflowStepsNavigator
        merchflowId={merchflowId}
        activeStep="S1"
        s0UserTriggerId={firstDoneS1Solution?.s0_user_trigger_id}
      />

      {data === undefined && <PageStatus label="Loading CDT1 mudmaps..." icon="spinner" />}

      {data && (
        <Flex flexWrap="wrap" gap="20px">
          {data.map((s1Solution, i) => (
            <Flex key={i} direction="column" gap="5px">
              <Flex justify="between" align="center">
                <Text variant="body1" color={Color.primary}>
                  {s1Solution.template_id}
                </Text>
                <S1LogsButton
                  merchflowId={merchflowId}
                  s1UserTriggerId={s1UserTriggerId}
                  templateId={s1Solution.template_id}
                />
              </Flex>
              <Link
                to={routeToUrl(
                  pages.merchflows_merchflowId_S1_s1UserTriggerId_Templates_templateId_,
                  {
                    merchflowId,
                    s1UserTriggerId,
                    templateId: s1Solution.template_id,
                  },
                )}
              >
                <PogOverviewContainer>
                  <PogOverview
                    status={
                      ((s1Solution.status === "NOT_STARTED" ||
                        s1Solution.status === "IN_PROGRESS") &&
                        "IN_PROGRESS") ||
                      (s1Solution.status === "ERROR" && "ERROR") ||
                      "NONE"
                    }
                    statusMessage={
                      ((s1Solution.status === "NOT_STARTED" ||
                        s1Solution.status === "IN_PROGRESS") &&
                        "Loading mudmap...") ||
                      (s1Solution.status === "ERROR" && "Mudmap failed")
                    }
                    pog={s1Solution.status === "DONE" && s1Solution.solution}
                    isShowMetrics={false}
                    isRenderingAsImage={false}
                  />
                </PogOverviewContainer>
              </Link>
            </Flex>
          ))}
        </Flex>
      )}
    </Page>
  );
};
